import { render, staticRenderFns } from "./BottomTabbar.vue?vue&type=template&id=861c369e&scoped=true"
import script from "./BottomTabbar.vue?vue&type=script&lang=js"
export * from "./BottomTabbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861c369e",
  null
  
)

export default component.exports